import React from "react";

export const YardIcon = ({
  width = 16,
  height = 16,
  color1 = "#000000",
  className = "",
  cursor = "pointer",
  style = {},
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    className={className}
    cursor={cursor}
    fill="none"
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.833 1.32031C14.4758 1.32031 15 1.8445 15 2.4873V13.333C15 13.9758 14.4758 14.5 13.833 14.5H2.16699C1.52421 14.5 1.00005 13.9758 1 13.333V2.4873C1 1.8445 1.52418 1.32031 2.16699 1.32031H13.833ZM2 13.333C2.00005 13.4235 2.0765 13.5 2.16699 13.5H3.5V12.1689L2 11.334V13.333ZM4.66699 11.167C4.57508 11.167 4.50023 11.2412 4.5 11.333V11.5811L7.01758 12.9834H4.96191L4.5 12.7256V13.5H7.5V11.333C7.49977 11.2412 7.42492 11.167 7.33301 11.167H4.66699ZM8.66699 11.167C8.57508 11.167 8.50023 11.2412 8.5 11.333V13.5H11.5V12.7256L11.0381 12.9834H8.98242L11.5 11.5811V11.333C11.4998 11.2412 11.4249 11.167 11.333 11.167H8.66699ZM12.5 12.1689V13.5H13.833C13.9235 13.5 13.9999 13.4235 14 13.333V11.334L12.5 12.1689ZM2.16699 2.32031C2.07647 2.32031 2 2.39678 2 2.4873V10.0938C2 10.1539 2.03608 10.2101 2.08008 10.2344L2.08301 10.2363L3.53613 11.0449C3.6646 10.5402 4.12222 10.167 4.66699 10.167H7.33301C7.38965 10.167 7.44552 10.1719 7.5 10.1797V8C7.50005 7.35571 8.02269 6.83301 8.66699 6.83301H11.333C11.9773 6.83301 12.5 7.35571 12.5 8V11.0244L13.9199 10.2344C13.9639 10.2101 14 10.1539 14 10.0938V2.4873C14 2.39678 13.9235 2.32031 13.833 2.32031H2.16699ZM8.66699 7.83301C8.57498 7.83301 8.50005 7.90799 8.5 8V10.167H11.5V8C11.5 7.90799 11.425 7.83301 11.333 7.83301H8.66699Z"
      fill={color1}
    />
  </svg>
);

export default YardIcon;
